<template>
	<div>
		<app-table
			class="mt-5"
			name="companies"
			:filter-columns="false"
			:class="{ 'is-not-selectable' : isAssigned }"
			:check-all="checkAll"
			:current-page="currentPage"
			:last-page="lastPage"
			:columns="columns"
			:rows="rows"
			:selectable="!isAssigned"
			@on-page="$emit('on-page', $event)"
			@row-is-selected="$emit('row-is-selected', $event)"
			@on-selected-all="$emit('on-selected-all', $event)"
			@on-search-event="$emit('on-search', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td :class="{ 'is-not-selectable' : isAssigned }">
					{{ props.row.code }}
				</td>
				<td>{{ props.row.description }}</td>
				<td @click.stop="stopClick">
					<v-tooltip top v-if="!isAssigned">
						<v-switch
							slot="activator"
							v-model="props.row.flagEdit"
							color="success"
							class="justify-center align-center my-0 pt-0"
							hide-details
						></v-switch>
						<span>{{ allowEdit(props.row) }}</span>
					</v-tooltip>
					<v-tooltip top v-else>
						<v-switch
							slot="activator"
							v-model="props.row.flagEdit"
							color="success"
							class="justify-center align-center my-0 pt-0"
							hide-details
							@change="updateStateEditRule(props.row)"
						></v-switch>
						<span>{{ allowEdit(props.row) }}</span>
					</v-tooltip>
				</td>
				<td @click.stop="stopClick">
					<v-tooltip top v-if="!isAssigned">
						<v-switch
							slot="activator"
							v-model="props.row.sign"
							:append-icon="props.row.sign === 1 ? 'add' : 'remove'"
							color="success"
							class="justify-center align-center my-0 pt-0 switch-rule"
							:true-value="1"
							:false-value="2"
							hide-details
						></v-switch>
						<span>{{ signLabel(props.row) }}</span>
					</v-tooltip>
					<v-tooltip top v-else>
						<v-switch
							slot="activator"
							v-model="props.row.sign"
							:append-icon="props.row.sign === 1 ? 'add' : 'remove'"
							color="success"
							class="justify-center align-center my-0 pt-0 switch-rule"
							:true-value="1"
							:false-value="2"
							hide-details
							@change="updateStateEditRule(props.row)"
						></v-switch>
						<span>{{ signLabel(props.row) }}</span>
					</v-tooltip>
				</td>
				<td v-if="actionsExist" @click.stop="stopClick">
					<app-tooltip-button
						color="error"
						icon="delete"
						text="Eliminar"
						@click-icon="onDeleteRule(props.row)"
					/>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
	import appTooltipButton from '@/components/shared/app-tooltip-button';

	function actionsExist() {
		return this.columns.find(c => c.flagVisible);
	}

	function allowEdit({ flagEdit }) {
		return flagEdit ? 'Sí' : 'No';
	}

	function signLabel({ sign }) {
		return sign === 1 ? 'Debe' : 'Haber';
	}

	async function updateStateEditRule(row) {
		const { flagEdit, sign, definitionDetail } = row;
		const body = {
			flagEdit: typeof flagEdit === 'number' ? flagEdit === 1 : flagEdit,
			sign: Number(sign),
		};
		try {
			await this.$http.patch(`/accounting-definition-details-update/${definitionDetail.id}`, body);
			this.showNotification('Se actualizo correctamente');
			this.$emit('load-data');
		} catch (error) {
			this.showGenericError();
		}
	}

	async function onDeleteRule(row) {
		const { definitionDetail } = row;
		try {
			await this.$http.delete(`accounting-definition-details/${definitionDetail.id}`);
			this.showNotification('Se elimino la regla de la definición contable');
			this.$emit('load-data');
		} catch (error) {
			this.showGenericError();
		}
	}

	export default {
		name: 'rules-assign-list',
		components: {
			appTooltipButton,
		},
		computed: {
			actionsExist,
		},
		methods: {
			allowEdit,
			signLabel,
			updateStateEditRule,
			onDeleteRule,
		},
		props: {
			checkAll: {
				default: false,
				type: Boolean,
			},
			columns: {
				type: Array,
				required: true,
			},
			currentPage: {
				type: Number,
				default: 1,
			},
			isAssigned: {
				default: false,
				type: Boolean,
			},
			lastPage: {
				type: Number,
				default: 0,
			},
			rows: {
				type: Array,
				required: true,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/rules/rules-assign-list.vue